import { isAfter, isEqual } from "date-fns";
import { TZDate } from "@date-fns/tz";

export const checkStationAvailability = (station, timezone) => {
  const now = TZDate.tz(timezone);
  now.setSeconds(0);
  now.setMilliseconds(0);

  // Time window check (slot_end)
  const slotEndStr = station?.slot_end || "23:59:59";
  const [hours = 23, minutes = 59, seconds = 0] = slotEndStr
    .split(":")
    .map((v) => Number(v));

  const slotEnd = new TZDate(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    hours,
    minutes,
    seconds,
    timezone,
  );

  if (isAfter(now, slotEnd) && !isEqual(now, slotEnd)) {
    return false;
  }

  // Order max-threshold check: hide station when current active orders >= max
  const maxThresholdRaw = station?.order_max_threshold;
  if (
    maxThresholdRaw !== undefined &&
    maxThresholdRaw !== null &&
    maxThresholdRaw !== ""
  ) {
    const maxThreshold = Number(maxThresholdRaw);
    if (!Number.isNaN(maxThreshold)) {
      // Try several possible shapes for current orders count
      let currentOrdersCount = 0;
      if (
        station &&
        typeof station.statistics === "object" &&
        station.statistics !== null
      ) {
        const stats = station.statistics;
        currentOrdersCount =
          stats.orders_in_progress ??
          stats.in_progress ??
          stats.current_orders ??
          stats.current_orders_count ??
          stats.active_orders ??
          stats.active_orders_count ??
          stats.orders_count ??
          (Array.isArray(stats.orders) ? stats.orders.length : undefined) ??
          currentOrdersCount;
      }

      if (
        (currentOrdersCount === undefined || currentOrdersCount === null) &&
        Array.isArray(station?.orders)
      ) {
        currentOrdersCount = station.orders.filter(
          (o) => o.status === 0,
        ).length;
      }

      currentOrdersCount = Number(currentOrdersCount) || 0;

      if (maxThreshold > 0 && currentOrdersCount >= maxThreshold) {
        return false;
      }
    }
  }

  return true;
};
